import React from "react";

const Banner = () => {
  return (
    <>
      <div className="banner-container">
        <img
          src="https://assets.oyoroomscdn.com/cmsMedia/f0be8dc3-e384-40b3-89f9-a0a0109159ce.jpg"
          alt="OYO"
          className="banner__cardImage"
        />
        <img
          src="https://assets.oyoroomscdn.com/cmsMedia/9545ff27-d9d3-41ab-b317-79ad722956e7.png"
          alt="Sale"
          className="banner__cardImage mt-lg-4"
        />
      </div>
    </>
  );
};

export default Banner;
